import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { from } from 'rxjs'
import { map, switchMap, tap } from 'rxjs/operators'
import { PrefixesService } from 'src/services/data/prefixes.service'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { createPrefix, createPrefixFailure, createPrefixSuccess, deletePrefix, deletePrefixFailure, deletePrefixSuccess, loadPrefixes, loadPrefixesFailure, loadPrefixesSuccess, updatePrefix, updatePrefixFailure, updatePrefixSuccess } from './prefix.actions'

@Injectable()
export class PrefixEffects {
  private actions$ = inject(Actions)
  private Prefixes = inject(PrefixesService)
  private toaster = inject(ToasterService)


  loadPrefixes$ = createEffect(() => this.actions$.pipe(
    ofType(loadPrefixes),
    switchMap(() =>
      from(this.Prefixes.getPrefixes()).pipe(
        map(prefixes => loadPrefixesSuccess({ prefixes })),
        catchAndLog(this.toaster, 'Unable to fetch prefixes', loadPrefixesFailure)))))

  createPrefix$ = createEffect(() => this.actions$.pipe(
    ofType(createPrefix),
    tap(() => this.toaster.progress('Creating prefix...')),
    switchMap(action =>
      from(this.Prefixes.create(action.prefix)).pipe(
        map(prefix => createPrefixSuccess({ prefix })),
        tap(() => this.toaster.success('Prefix created successfully.')),
        catchAndLog(this.toaster, 'Unable to create prefix', createPrefixFailure)))))

  updatePrefix$ = createEffect(() => this.actions$.pipe(
    ofType(updatePrefix),
    tap(() => this.toaster.progress('Updating prefix...')),
    switchMap(action =>
      from(this.Prefixes.update({ ...action.prefix, prefix_id: action.id })).pipe(
        map(prefix => updatePrefixSuccess({ prefix })),
        tap(() => this.toaster.success('Prefix updated successfully.')),
        catchAndLog(this.toaster, 'Unable to update prefix', updatePrefixFailure)))))

  deletePrefix$ = createEffect(() => this.actions$.pipe(
    ofType(deletePrefix),
    tap(() => this.toaster.progress('Deleting prefix...')),
    switchMap(action =>
      from(this.Prefixes.remove(action.id)).pipe(
        map(() => deletePrefixSuccess({ id: action.id })),
        tap(() => this.toaster.success('Prefix deleted successfully.')),
        catchAndLog(this.toaster, 'Unable to delete prefix', deletePrefixFailure)))))
}